import { z } from 'zod';

export const searchSchema = z.object({
  dvt: z.string().min(1, 'Mã đơn vị tính là bắt buộc'),
  ten_dvt: z.string().min(1, 'Tên đơn vị tính là bắt buộc'),
  ten_khac: z.string().optional(),
  dvt2: z.string().optional(),
  status: z.coerce.number()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialValues: SearchFormValues = {
  dvt: '',
  ten_dvt: '',
  ten_khac: '',
  dvt2: '',
  status: 1
};
